import React from 'react'
import PropTypes from 'prop-types'
import API from 'fw/system/API'
import { Form } from 'fw/forms'
import { Button, Col, Row, Glyphicon, Label } from 'react-bootstrap'
import * as FormManager from 'fw/forms/form/FormManager'
import * as Help from 'modules/app/Help'
import * as Recent from 'modules/app/Recent'
import * as Modals from 'fw/globals/Modals'
import * as Block from 'fw/globals/Block'

class SetupTab extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
		this._isMounted = false;
	}

	initialForm() { return null; }
	privileges() { return null; }
	skipValidations() { return false; }
	urls() { return {}; }
	saveRequest() { return null; }
	newRequest() { return null; }
	loadRequest() { return null; }
	getRequest() { return null; }
	ready() { return null; }
	validate() { return true; }
	renderContent() { return null; }
	renderForm() { return null; }
	beforeSave(cb) { cb(); }
	afterSave() { }
	afterSaveTabSelect() { }
	isEnabled(data) { return true; }
	isValidated(data) { return true; }

	initialState = () => {
		return {
			title: "-",
			active: false,
			adding: false,
			enabled: false,
			isValidated: true,
			blocked: false,
			dirty: false,
			loading: true,
			saving: false,
			disabled: false,
			tooltips: this.props.tooltips,
			showTitle: this.props.showTitle,
			buttons: { cancel: false, save: false },
			showButtons: { cancel: this.props.showButtons.cancel, save: this.props.showButtons.save },
			privileges: this.privileges(),
			skipValidations: this.skipValidations(),
			data: {},
			form: {
				...this.initialForm(),
				original: {}
			}
		}
	}

	reload = () => {
		// For reloads we block, as we know there's something in the screen already
		Block.block();

		// Load or get
		if (this.urls().load !== undefined)
			this.load(this.props.selectedId);
		else
			this.get(this.props.selectedId);
	}

	show = (active, selectedId) => {
		if (!active)
			return null;

		// Set help
		if (this.props.helpKey)
			Help.setHelp(this.props.helpKey)
		else
			Help.clearHelp();

		// Load or get
		if (this.urls().load !== undefined)
			this.load(selectedId);
		else
			this.get(selectedId);
	}

	load = (selectedId) => {
		this.setState({ blocked: true, loading: true });

		new API().get(this.urls().load, this.loadRequest(selectedId),
			{
				success: (r) => {
					this.setState({ data: r.data });
					this.get(selectedId);
				}
			});
	}

	get = (selectedId) => {

		// New vs edit
		if (!selectedId) {
			this.new();
			return;
		}

		const self = this;
		const rq = this.getRequest(selectedId);

		this.setState({ blocked: true });

		new API().get(this.urls().get, rq,
			{
				success: (r) => {
					if (!self._isMounted)
						return;

					this.setState({
						title: (r.data && r.data.title) || this.state.title,
						form: {
							...r.data,
							original: JSON.parse(JSON.stringify(r.data))
						},
						adding: false,
						loading: false,
						enabled: self.isEnabled(r.data) && self.state.privileges.edit,
						isValidated: self.isValidated(r.data),
						buttons: { save: true, cancel: true }
					}, function () {
						// Add recent
						Recent.add({
							activityTitle: (r.data && r.data.recentTitle) || this.state.title,
							recentType: this.props.recentType,
							entityKey: selectedId
						});

						// Trigger ready
						Block.unblock();
						self.ready();
					});
				},
				error: (r) => {

					if (!self._isMounted)
						return;

					if (r.error.errorMessage)
						this.props.onError(r.error);

					this.props.onNotFound(r.error);
				}
			},
			{ block: false });
	}

	new = () => {
		const me = this;

		// Server new
		const newEndpointDefined = (this.urls().new !== undefined);

		// Set adding state
		this.setState((prevState) => {
			return Object.assign(this.initialState(), {
				data: prevState.data,
				title: "New",
				adding: true,
				loading: newEndpointDefined,
				enabled: true,
				buttons: { save: true, cancel: true }
			})
		});

		// Get new info
		if (newEndpointDefined) {
			new API().get(this.urls().new, this.newRequest(),
				{
					success: (r) => {
						if (!me._isMounted)
							return;

						this.setState((prevState) => {
							return Object.assign(prevState, {
								loading: false,
								title: (r.data && r.data.title) || "New",
								form: {
									...r.data,
									original: JSON.parse(JSON.stringify(r.data))
								}
							})
						});
					}
				},
				{ block: false });
		}
	}

	save = (options) => {
		// skip validations
		if (this.state.skipValidations !== true) {
			// Form validations
			if (this.state.isValidated && !this._form.validate())
				return;

			// Custom validations
			if (!this.validate())
				return;
		}

		// Proceed
		const me = this;
		let url = this.urls().save;
		let rq = {};

		if (this.state.adding && this.createRequest)
			rq = this.createRequest();
		else
			rq = this.saveRequest();

		// Use specific fow version from server?
		if (options && options.rowVersion)
			rq.rowVersion = options.rowVersion;

		// Set URL based for creationg (save or create)
		if (this.state.adding && this.urls().create)
			url = this.urls().create;

		this.setState({
			saving: true
		}, function () {
			new API().post(url, rq, {
				success: (r) => {
					// Callback? Useful when called from tabs
					if (options && options.success) {
						this.afterSaveTabSelect(r.data.entityId, r.data);
						options.success();
						return;
					}

					this.setState({
						title: (r.data && r.data.title) || this.state.title,
						saving: false,
						dirty: false,
						rowVersion: r.data.rowVersion,
						form: {
							...this.state.form,
							...r.data,
							original: {
								...this.state.form,
								...r.data
							}
						}
					}, () => { this.afterSave(r.data.entityId, r.data); });

					this.props.onSuccess(r.message);
					this.props.onSave(r.data.entityId);
					FormManager.reset();

					// Added a new element? That goes to recent too...
					if (this.state.adding) {
						// Add recent
						Recent.add({
							activityTitle: (r.data && r.data.recentTitle) || (r.data && r.data.title),
							recentType: this.props.recentType,
							entityKey: r.data.entityId
						});
					}
				},
				error: r => {
					if (r.data && r.data.rowVersion) {
						Modals.confirm(r.error.errorMessage,
							function () {
								me.save({
									rowVersion: r.data.rowVersion,
									success: options && options.success
								});
							},
							function () {
								me.setState({ saving: false });
								me.get(r.data.entityId);
							}
						);
					} else {
						me.setState({ saving: false });
						this.props.onError(r.error);
					}
				}
			})
		});
	}

	cancel = () => {
		this.setState((prevState) => {
			return Object.assign(this.initialState(), {
				data: prevState.data
			});
		});

		this.props.onCancel();
	}

	dirt = () => {
		this.setState({
			dirty: true
		}, function () {
			FormManager.dirt(this._form);
		});
	}

	isDirty() {
		return this.state.dirty;
	}

	// Handlers
	handleSubmit = () => {
		const me = this;

		this.beforeSave(() => {
			me.save();
		});
	}

	handleCancel = () => {
		const me = this;
		FormManager.checkUnsavedChanges(() => {
			me.cancel();
		})
	}

	handleChange = (form, callback) => {
		this.setState({ form }, callback);
	}

	handleDirt = () => {
		this.dirt();
	}

	// React
	componentWillReceiveProps(nextProps) {
		if (nextProps.active !== this.props.active || 
			nextProps.selectedId !== this.props.selectedId || 
			nextProps.adding !== this.props.adding)
			this.show(nextProps.active, nextProps.selectedId);
	}

	componentDidMount() {
		this._isMounted = true;

		this.show(this.props.active, this.props.selectedId);
	}

	componentDidUpdate(prevPros, prevState) {
		if (this.state.adding && prevState.loading && !this.state.loading) {
			// Give some time for blocks, blurs, etc... before calling this ready
			setTimeout(this.ready, 100);
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

    setTip = (property) => {
        const tooltip = this.state.tooltips.find(t => t.code === property)
        return tooltip !== undefined ? tooltip.text : null
    }

	renderButtons = () => {
		// Enable cancel if present
		const disableCancel = !this.state.buttons.cancel;

		// Enable save if present, and form is dirty
		const disableSave = !this.state.buttons.save || !this.state.dirty;

		//Show cancel
		const showCancel = this.state.showButtons.cancel;

		//Show save 
		const showSave = this.state.showButtons.save;

		return (
			<React.Fragment>
				<hr />
				<div className="pull-right">
					{((showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)) && <Button id="btnCancel" bsStyle="link" onClick={this.handleCancel} disabled={disableCancel}>Cancel</Button>}
					{((showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)) && <Button id="btnSave" type="submit" bsStyle="primary" disabled={disableSave}>Save Changes</Button>}
				</div>
			</React.Fragment>
		);
	}

	renderIndicator = () => {
		if (this.state.saving)
			return <Label bsStyle="info" className="pull-right" style={{ padding: "5px" }}>Saving...</Label>
		else if (this.state.dirty)
			return <Glyphicon glyph="pencil" className="pull-right" style={{ color: "red" }} />
		else
			return null;
	}

	render() {
		if (this.state.loading)
			return null;
		return (
			<React.Fragment>
				{this.renderIndicator()}
				{this.props.showTitle &&
					<React.Fragment>
						<h2>{this.state.title}</h2>
						<hr />
					</React.Fragment>
				}
				{this.renderContent()}
				<Form
					onSubmit={this.handleSubmit}
					onChange={this.handleChange}
					onDirt={this.handleDirt}
					values={this.state.form}
					unsavedChangesWarning={true}
					disabled={!this.state.enabled || this.props.disabled}
					ref={(form) => { this._form = form }}>
					<Row>
						<Col md={this.renderActions ? 10 : 12}>
							{this.renderForm()}
						</Col>
						<Col md={1} mdPush={1}>
							{this.renderActions && this.renderActions()}
						</Col>
					</Row>
					{this.renderButtons()}
				</Form>
			</React.Fragment>
		)
	}
}

SetupTab.propTypes = {
	onSave: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired
}

export default SetupTab;



// WEBPACK FOOTER //
// ./src/areas/shared/pages/setup/SetupTab.js